import { createFileRoute } from '@tanstack/react-router';

import { AppPageContent } from '@/features/shared/components/AppPageContent';
import {
  AppPageHeader,
  BreadcrumbItemProps,
} from '@/features/shared/components/AppPageHeader';
import { SubjectTracksRoot } from '@/features/subject-tracks/components/SubjectTracksRoot';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/_app/app/admin-section/subject-tracks')({
  component: SubjectTracksComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },
  {
    label: 'Subject Tracks',
    link: { to: '/app/admin-section/subject-tracks' },
  },
];

function SubjectTracksComponent() {
  return (
    <AppPageContent>
      <AppPageHeader breadcrumbItems={breadcrumbItems} />
      <SubjectTracksRoot />
    </AppPageContent>
  );
}
